module.exports = __webpack_public_path__ + "img/icon-基金-s@2x_1612a.png";